<h1 mat-dialog-title class="d-flex align-items-center justify-content-between">
    <span class="dialog-header">Rating and Comments</span>
    <i mat-dialog-close class="fa fa-times model_close cursor-pointer"></i>
</h1>
<div mat-dialog-content class="popup-content">
    <div class="viewRating">
        <div><span class="title">Title: </span><span class="title-value">{{title}}</span></div>
        <div class="view-rating-container">
            <div class="title">Overall Rating</div>
            <div class="star-rating">
                <span class="star-fixed"
                *ngFor="let star of stars; let i = index"
                [ngClass]="{'filled': i < overallRating}">
                &#9733;
                </span>
                <span class="rating-point">{{ overallRating | number:'1.1-1'}}</span>
            </div>
        </div>
    </div>
    <div class="rating-container" >
        <div class="title header">Rating:</div>
        <div class="star-rating">
            <span class="star"
            *ngFor="let star of stars; let i = index"
            (click)="rate(i + 1)"
            [ngClass]="{'filled': i < rating}">
            &#9733;
            </span>
            <span class="rating-point">{{ rating | number:'1.1-1'}}</span>
        </div>
    </div>
    <div>
        <span class="title header" style="margin-bottom: 5px;">Comments: </span>
        <!-- <span *ngIf="comments.length==0" class="description">No Comments yet</span> -->
        <div>
            <textarea class="txt-area" [(ngModel)]="comment" tabindex="-1" placeholder="Enter comments here... " autocomplete="off"></textarea>
        </div>
        <div *ngFor="let i of comments">
            <div class="txt-area" *ngIf="i.comments!==null || i.comments!==''">
                <div style="margin-bottom: 10px;">
                    <!-- <img class="circle-image" src="../../../assets/images/user_avtar.png"/> -->
                    <div class="avatar">{{i.empName[0] | titleCase}}</div>
                    <span class="comment-heading">{{i.empName | titleCase}}</span>
                </div>
                <div class="comment-desc">{{i.comment}}</div>
                <div class="timeTag">{{i.timeAgo}}</div>
            </div>
        </div>
    </div>
</div>
<div mat-dialog-actions class="popup-buttons d-flex justify-content-end">
    <button mat-dialog-close class="custom_btn inverted_btn_base ml-2">Cancel</button>
    <button class="custom_btn primary_btn_base ml-2" (click)="save()">Submit</button>
</div>
